import { render, staticRenderFns } from "./ExternalAd.vue?vue&type=template&id=cc71c5b6"
import script from "./ExternalAd.vue?vue&type=script&lang=js"
export * from "./ExternalAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports